/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteImportPreviewMutationResponse,
  DeleteImportPreviewPathParams,
  DeleteImportPreview404,
} from '../types/DeleteImportPreview'

function getDeleteImportPreviewUrl({
  import_number,
}: {
  import_number: DeleteImportPreviewPathParams['import_number']
}) {
  const res = {
    method: 'DELETE',
    url: `/api/v1/importengine/previews/v2/${import_number}/` as const,
  }
  return res
}

/**
 * @summary Delete an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/}
 */
export async function deleteImportPreview(
  {
    import_number,
  }: { import_number: DeleteImportPreviewPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteImportPreviewMutationResponse,
    ResponseErrorConfig<DeleteImportPreview404>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteImportPreviewUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
